import moment from "moment-timezone";
import React from "react";

import useTodayTomorrowString from "../../../../../hooks/booking/useTodayTomorrowString";

/**
 * Component which formats the time of an appointment and renders it along with a line 2
 */
const Details = ({
  time,
  line2,
  locationTimezone,
}: {
  /** The appointment start time in millis since the unix epoch. */
  time: number;
  /** The location.timezone. */
  locationTimezone?: string | null;
  /** The second  that we're trying to target. */
  line2: string;
}) => {
  const tz = locationTimezone ?? moment.tz.guess();
  const apptTime = moment(time).tz(tz);
  const dateString = useTodayTomorrowString(apptTime, moment().tz(tz));

  return (
    <div className="flex flex-1 flex-col justify-center py-2 pr-4 overflow-hidden">
      <p className="font-i font-semibold">{dateString}</p>
      <p className="font-i truncate">{line2}</p>
    </div>
  );
};

export default Details;
